import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faGlobe, faLink, faShieldAlt, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BBadge, BButton } from "bootstrap-vue";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { Toast } from "@/composables/toast";
import { useUserStore } from "@/stores/userStore";
import { copy } from "@/utils/clipboard";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowIndicators',
    props: {
        workflow: null,
        publishedView: { type: Boolean }
    },
    emits: ["update-filter"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faShieldAlt, faLink, faGlobe, faUsers, faUser);
        const router = useRouter();
        const userStore = useUserStore();
        const publishedTitle = computed(() => {
            var _a;
            if (((_a = userStore.currentUser) === null || _a === void 0 ? void 0 : _a.username) === props.workflow.owner) {
                return "Published by you. Click to view all published workflows by you";
            }
            else {
                return `Published by '${props.workflow.owner}'. Click to view all published workflows by '${props.workflow.owner}'`;
            }
        });
        const shared = computed(() => {
            if (userStore.currentUser) {
                return userStore.currentUser.username !== props.workflow.owner;
            }
            else {
                return false;
            }
        });
        const sourceType = computed(() => {
            var _a, _b, _c;
            if ((_a = props.workflow.source_metadata) === null || _a === void 0 ? void 0 : _a.url) {
                return "url";
            }
            else if ((_b = props.workflow.source_metadata) === null || _b === void 0 ? void 0 : _b.trs_server) {
                return `trs_${(_c = props.workflow.source_metadata) === null || _c === void 0 ? void 0 : _c.trs_server}`;
            }
            else {
                return "";
            }
        });
        const sourceTitle = computed(() => {
            if (sourceType.value.includes("trs")) {
                return `Imported from TRS ID (version: ${props.workflow.source_metadata.trs_version_id}). Click to copy ID`;
            }
            else if (sourceType.value == "url") {
                return `Imported from ${props.workflow.source_metadata.url}. Click to copy link`;
            }
            else {
                return `Imported from ${props.workflow.source_type}`;
            }
        });
        function onCopyLink() {
            if (sourceType.value == "url") {
                copy(props.workflow.source_metadata.url);
                Toast.success("URL copied");
            }
            else if (sourceType.value.includes("trs")) {
                copy(props.workflow.source_metadata.trs_tool_id);
                Toast.success("TRS ID copied");
            }
        }
        function onViewMySharedByUser() {
            router.push(`/workflows/list_shared_with_me?owner=${props.workflow.owner}`);
            emit("update-filter", "user", `'${props.workflow.owner}'`);
        }
        function onViewUserPublished() {
            router.push(`/workflows/list_published?owner=${props.workflow.owner}`);
            emit("update-filter", "user", `'${props.workflow.owner}'`);
        }
        return { __sfc: true, props, emit, router, userStore, publishedTitle, shared, sourceType, sourceTitle, onCopyLink, onViewMySharedByUser, onViewUserPublished, faGlobe, faLink, faShieldAlt, faUser, faUsers, FontAwesomeIcon, BBadge, BButton, UtcDate };
    }
});
